import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  title?: string;
  quote: string;
  author: string;
  details: string;
  compact?: boolean;
  image?: string;
}
export function TestimonialCard({
  title,
  quote,
  author,
  details,
  compact = false,
  image
}: TestimonialCardProps) {
  return <div className={`bg-white border-l-4 border-[#4caf50] p-6 shadow-sm my-6 ${compact ? 'text-sm' : ''}`} data-id="element-70">
      <div className="flex space-x-1 mb-3 text-[#ffa726]" data-id="element-71">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-72" />)}
      </div>
      {title && <h4 className="font-bold text-[#1a4d2e] mb-3 text-lg leading-tight" data-id="element-73">
          "{title}"
        </h4>}
      <blockquote className={`text-[#2c2c2c] mb-4 font-serif leading-relaxed ${compact ? 'text-sm' : 'text-base'}`} data-id="element-74">
        "{quote}"
      </blockquote>
      <div className="flex items-center space-x-3 mt-4 pt-4 border-t border-gray-100" data-id="element-75">
        {!compact && <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-76">
            {image ? <img src={image} alt={author} className="w-full h-full object-cover" data-id="element-77" /> : <div className="w-full h-full bg-gray-300 flex items-center justify-center text-gray-500 text-xs" data-id="element-78">
                IMG
              </div>}
          </div>}
        <div data-id="element-79">
          <div className="font-bold text-[#1a4d2e] text-sm" data-id="element-80">{author}</div>
          <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-81">
            {details}
          </div>
        </div>
      </div>
    </div>;
}